/**
 * Generate the next available cost-position code under a given parent.
 *
 * Format: `${parentCode}-${NNN}` (3-digit suffix). Picks max(existing suffix) + 1
 * and then walks forward until the candidate is unique across ALL categories
 * (not just siblings), to avoid colliding with manually-typed codes elsewhere.
 */
export function generateNextCostPositionCode(
  parentCode: string,
  allCategoryCodes: string[]
): string {
  const prefix = parentCode.toUpperCase();
  const re = new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}-(\\d+)$`);
  const used = new Set(allCategoryCodes.map((c) => c.toUpperCase()));

  let max = 0;
  for (const code of allCategoryCodes) {
    const m = code.toUpperCase().match(re);
    if (m) {
      const n = parseInt(m[1], 10);
      if (!isNaN(n) && n > max) max = n;
    }
  }

  let next = max + 1;
  let candidate = `${prefix}-${String(next).padStart(3, '0')}`;
  while (used.has(candidate)) {
    next += 1;
    candidate = `${prefix}-${String(next).padStart(3, '0')}`;
  }
  return candidate;
}

export function isDuplicateCodeError(err: any): boolean {
  if (!err) return false;
  if (err.code === '23505') return true;
  const msg = String(err.message || '');
  return msg.includes('expense_categories_code_key') || msg.includes('duplicate key');
}
